import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowBack } from 'react-icons/io';
import theme from '@styles/theme';

type SideBarProps = {
    GO_BACK?: boolean;
    handleCustomGoBack?: () => void;
    children?: ReactNode;
};

const SideBar = ({ GO_BACK, handleCustomGoBack, children }: SideBarProps) => {
    const navigate = useNavigate();

    return (
        <Wrapper>
            {GO_BACK && (
                <GoBackButton
                    onClick={() =>
                        handleCustomGoBack ? handleCustomGoBack() : navigate(-1)
                    }
                >
                    <IoMdArrowBack size={24} />
                </GoBackButton>
            )}
            {children}
        </Wrapper>
    );
};

export default SideBar;

const Wrapper = styled.aside`
    padding-top: 28px;
    padding-right: 20px;
    width: 163px;
`;

const GoBackButton = styled.button`
    width: 40px;
    font-size: 30px;
`;

export const TabList = styled.ul<{ $row?: boolean }>`
    ${({ $row }) =>
        $row &&
        css`
            display: flex;
            align-items: center;
            gap: 0 20px;
            margin-bottom: 22px;
        `};
`;

export const TabItem = styled.li<{ $height?: string; $cursor?: string }>`
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: ${({ $height }) => ($height ? $height : '40px')};
    cursor: ${({ $cursor }) => ($cursor ? $cursor : 'pointer')};
`;

export const TabMenu = styled.div<{ $active?: boolean }>`
    position: relative;
    width: 100%;
    height: 15px;
    font-size: 14px;
    color: ${theme.colors.whiteColor};
    transition: 0.25s;

    &::before {
        content: attr(data-text);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: PretendardRegular, sans-serif;
        color: ${theme.colors.sidebarGrayFontColor};
        opacity: 1;
        transition: 0.25s;
    }

    &::after {
        content: attr(data-text);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: PretendardSemiBold, sans-serif;
        color: ${theme.colors.sidebarGrayFontColor};
        opacity: 0;
        transition: 0.25s;
    }

    &:hover {
        &::before {
            opacity: 0;
        }
        &::after {
            opacity: 1;
        }
    }

    ${({ $active }) =>
        $active &&
        css`
            &::before,
            &::after {
                color: ${theme.colors.blackColor};
            }

            &:hover {
                &::before {
                    opacity: 1;
                }
                &::after {
                    opacity: 0;
                }
            }
        `};
`;
